import React from 'react';
import { Stack, Typography } from '@mui/material';

import { EMPTY_VALUE } from './lib';

interface Props {
  rows: any[];
  action: 'added' | 'removed' | 'updated';
}

export const Details = ({ action, rows }: Props) => {
  const isSameValue = (left: unknown, right: unknown): boolean => JSON.stringify(left) === JSON.stringify(right);

  const filteredRows =
    action === 'updated'
      ? rows.filter(({ rawBefore, rawAfter }) => !isSameValue(rawBefore, rawAfter))
      : rows.filter(({ after, before }) => (action === 'added' ? after !== EMPTY_VALUE : before !== EMPTY_VALUE));

  if (!filteredRows.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        {action === 'updated' ? 'Details updated' : 'No additional details'}
      </Typography>
    );
  }

  return (
    <Stack>
      {filteredRows.map(({ label, before, after }) => (
        <Typography key={label} variant="body2">
          {label}: {action === 'updated' ? `${before} → ${after}` : action === 'added' ? after : before}
        </Typography>
      ))}
    </Stack>
  );
};
